import About from 'components/About';
import AddSpotFinished from 'components/AddSpotFinished';
import AddSpotStep1 from 'components/AddSpotStep1';
import AddSpotStep2 from 'components/AddSpotStep2';
import AddSpotStep3 from 'components/AddSpotStep3';
import AddSpotStep4 from 'components/AddSpotStep4';
import ContactUs from 'components/ContactUs';
import EditProfile from 'components/EditProfile';
import ForgotPassword from 'components/ForgotPassword';
import LoginRequiredModal from 'components/LoginRequired';
import NoHomeSelected from 'components/NoHomeSelected';
import ResetPassword from 'components/ResetPassword';
import SessionExpired from 'components/SessionExpired';
import SignIn from 'components/SignIn';
import SpotDetail from 'components/SpotDetail';
import UserDetail from 'components/UserDetail/UserDetail';
import FinishRegistration from 'components/FinishRegistration';
import SimpleSignup from 'components/SimpleSignup';
import EmailVerification from 'components/EmailVerification';
import TermsAndConditions from '../components/TermsAndConditions';
import AcceptTerms from '../components/AcceptTerms';
import PleaseContribute from '../components/PleaseContribute';
import { Welcome } from 'components/Welcome/Welcome';

export const PRIVACY_PRIVATE = 'PRIVACY_PRIVATE';
export const PRIVACY_PUBLIC = 'PRIVACY_PUBLIC';
export const ANONYMITY_ON = 'ANONYMITY_ON';
export const ANONYMITY_OFF = 'ANONYMITY_OFF';
export const ROUTES_DATA = [
    {
        path: '/welcome',
        component: () => <Welcome />,
    },
    {
        path: '/about',
        component: () => <About />,
    },
    {
        path: '/please-contribute',
        component: () => <PleaseContribute />,
    },
    {
        path: '/request-login',
        component: () => <LoginRequiredModal />,
        allowRedirect: false,
    },
    {
        path: '/sign-in',
        component: () => <SignIn />,
        allowRedirect: false,
    },
    {
        path: '/session-expired',
        component: () => <SessionExpired />,
    },
    {
        path: '/sign-up',
        component: () => <SimpleSignup />,
    },
    {
        path: '/finish-registration',
        component: () => <FinishRegistration />,
    },
    {
        path: '/add-spot',
        component: () => <AddSpotStep1 />,
    },
    {
        path: '/add-spot/step-1',
        component: () => <AddSpotStep1 />,
    },
    {
        path: '/add-spot/step-2',
        component: () => <AddSpotStep2 />,
    },
    {
        path: '/add-spot/step-3',
        component: () => <AddSpotStep3 />,
    },
    {
        path: '/add-spot/step-4',
        component: () => <AddSpotStep4 />,
    },
    {
        path: '/add-spot/finished',
        component: () => <AddSpotFinished />,
    },
    {
        path: '/spot-detail/:id',
        component: () => <SpotDetail />,
    },
    {
        path: '/user/:id',
        component: () => <UserDetail />,
    },
    {
        path: '/confirmEmail/:hash',
        component: () => <EmailVerification />,
    },
    {
        path: '/no-home-selected',
        component: () => <NoHomeSelected />,
    },
    {
        path: '/edit-profile',
        component: () => <EditProfile />,
    },
    {
        path: '/contact-us',
        component: () => <ContactUs />,
    },
    {
        path: '/terms-and-conditions',
        component: () => <TermsAndConditions />,
    },
    {
        path: '/accept-terms',
        component: () => <AcceptTerms />,
        allowRedirect: false,
    },
    {
        path: '/forgot-password',
        component: () => <ForgotPassword />,
        allowRedirect: false,
    },
    {
        path: '/reset-password/:hash',
        component: () => <ResetPassword />,
        allowRedirect: false,
    },
];
